let inject = ['$scope', '$uibModalInstance','modalOptions','SharedService'];

class ModalLocationController {
  constructor ($scope,$uibModalInstance,modalOptions, SharedService) {
    this.$scope = $scope;
    this.SharedService = SharedService;
    this.$uibModalInstance = $uibModalInstance;
    this.modalOptions = Object.assign({}, modalOptions);
    this.formData = {
      country:      {},
      state:        {},
      city:         {},
      neighborhood: {}
    };
    try{this.changeLocation= this.modalOptions.locationSelected.cityId >0 ? true : false;}
    catch (e) {

    }


    this.state = {};
    this.countries = this.modalOptions.locations;
    var cities =[];
    this.countries.forEach(function(val){
      val.states.forEach(function(val2){
        cities = cities.concat(val2.cities);
      });
    });

    this.cities = cities;
    /*if(this.modalOptions.locationSelected.cityId >0) {

      var that=this;
      var formData = {
        country:      {},
        state:        {},
        city:         {},
        neighborhood: {}
      };
      angular.forEach(that.countries, function(country, countryKey) {
        console.log(that.formData);
        // Set the state
        angular.forEach(that.countries[countryKey].states, function(state, stateKey) {
          if(that.modalOptions.locationSelected.stateId === state.id) {
            that.formData.state = state;


            // Set the city
            angular.forEach(this.countries[countryKey].states[stateKey].cities, function(city, cityKey) {
              if(that.modalOptions.locationSelected.cityId === city.id) {
                that.formData.city = city;
                that.formData.cityOther = city;
              }

              // Set the neighborhood
              angular.forEach(that.countries[countryKey].states[stateKey].cities[cityKey].neighborhoods,
                function(neighborhood, neighborhoodKey) {
                  if(that.modalOptions.locationSelected.neighborhoodId === neighborhood.id) {
                    that.formData.neighborhood = neighborhood;
                  }
                }
              );
            });

          }

          console.log(that.formData);

        });
        //this.formData=that.formData;
      });
    }/*/
  }

  setCityOther(city){
    this.formData.state = this.formData.country.states.filter(function(val){
      return val.cities.filter(function(val2){
        return val2.id === city.id;
      })[0];
    })[0];
    this.formData.city =this.formData.state.cities.filter(function(val){
      return val.id === city.id;
    })[0];
  }

  setDefaultCity() {
    try {
      if(this.formData.state.cities.length === 1) {
        this.formData.city = this.formData.state.cities[0];
        this.setDefaultNeighborhood();
      }
    }
    catch(e) {}
  }

  setDefaultNeighborhood() {
    try {
      if(this.formData.city.neighborhoods.length === 1) {
        this.formData.neighborhood = this.formData.city.neighborhoods[0];
      }
    }
    catch(e) {}
  }

  setDefaultState() {
    try {
      if(this.formData.country.states.length === 1) {
        this.formData.state = this.formData.country.states[0];

        if(this.formData.state.cities.length === 1) {
          this.formData.city = this.formData.state.cities[0];
          this.setDefaultCity();
        }
      }
    }
    catch(e) {}
  }

  setDeliveryLocation(form) {
    if(form.$valid && this.formData.city.id && this.formData.neighborhood.id ) {
      this.state = {};
      this.state.savingCoverageLocation = true;

      var countryId = '';
      var countryName = '';
      var stateId = '';
      var stateName = '';
      var cityId = '';
      var cityName = '';
      var neighborhoodId = '';
      var neighborhoodName = '';

      try { countryId = this.formData.country.id; countryName = this.formData.country.name; } catch(e) {}
      try { stateId   = this.formData.state.id; stateName = this.formData.state.name; } catch(e) {}
      try { cityId    = this.formData.city.id; cityName  = this.formData.city.name; } catch(e) {}
      try { cityId    = this.formData.city.id; cityName  = this.formData.city.name; } catch(e) {}
      try { neighborhoodId = this.formData.neighborhood.id; neighborhoodName = this.formData.neighborhood.name; } catch(e) {}

      var params = {
        countryId:        countryId,
        countryName:      countryName,
        stateId:          stateId,
        stateName:        stateName,
        cityId:           cityId,
        cityName:         cityName,
        neighborhoodId:   neighborhoodId,
        neighborhoodName: neighborhoodName
      };
      this.SharedService.setDeliveryLocation(params,null).then(response => {
        this.ok();
      }).catch(reason => {
        this.cancel();
      });

    }
  }






  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  ok() {
    this.$uibModalInstance.close();
  }
}

ModalLocationController.$inject = inject;

export default ModalLocationController;



/** WEBPACK FOOTER **
 ** ./www/components/shared/components/modal-location/modal-location.controller.js
 **/